/**
 * Handles all focus to anchor
 * @module ccExpMask to
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import 'jquery-mask-plugin';

// Expose the function as a jQuery plugin for ease of uses
export const PLUGIN_NAME = 'ccExpMask';
export const DEFAULTS = {
};

/**
 * Merges together all the options and the various conditions in which they
 * can be set.
 * @param  {jQuery} $el - button /element that opens modal
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @return {Object} Immutable version of the options
 */
const mergeOptions = ($el, options = {}) => {
    // Assign $modal to modal element either by options {} or $el's data attribute
    let opts = {};
    opts = Object.assign({}, DEFAULTS, $el.data(), options);
    return opts;
};
function setFormating($el, opts) {
    if ($el.length) {
        $el.mask('00/00');
    }
}

/**
 * Initializes focusTo.
 * @param {HTMLElement} el - button /element that opens focusTo
 * @param {Object} options - Options used for wiring up the focusTo
 * @param {Object} deregister - Performs a deregisteration on the plugin
 * @see DEFAULTS
 */
export default function ccExpMask(el, options = {}, { deregister }) {
    const $el = $(el);
    const opts = mergeOptions($el, options);
    setFormating($el, opts);
}

registerJQueryPlugin(PLUGIN_NAME, ccExpMask);


// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/cc-exp-mask.js